import PropTypes from 'prop-types';
import React from 'react';
import { toast } from 'react-toastify';
import Modal from '~/components/Modal';
import { productPaths } from '~/routes/paths';
import api, { endpoints } from '~/services/api';
import { showMessageError } from '~/util/errorutils';
import { SidebarPageHeader } from '~/components/SidebarPageHeader';

class EditProductModality extends React.Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({
        id: PropTypes.number,
      }).isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    const { history, location } = props;
    this.history = history;
    this.location = location;
    this.id = null;

    this.state = {
      loading: true,
      inputNome: '',

      // errors
      error_inputNome: false,
    };
  }

  /* LifeCicle:: Inicializa quando monta a DOM */
  componentDidMount() {
    if (!this.location.state || !this.location.state.id) {
      this.setLoading(false);
      toast('Erro ao consultar modalidade de produto.', {
        type: toast.TYPE.ERROR,
      });
      this.history.push(productPaths.productModality);
    } else {
      this.id = this.location.state.id;
      api
        .get(
          endpoints.product.modality.getProductModality(this.location.state.id)
        )
        .then(value => {
          if (value.data && value.data.data) {
            this.setState({
              inputNome: value.data.data.nome,
            });
          } else {
            toast('Erro ao consultar modalidade de produto.', {
              type: toast.TYPE.ERROR,
            });
            this.history.push(productPaths.productModality);
          }
        })
        .catch(() => {
          toast('Erro ao consultar modalidade de produto.', {
            type: toast.TYPE.ERROR,
          });
          this.history.push(productPaths.productModality);
        })
        .finally(() => {
          this.setLoading(false);
        });
    }
  }

  setLoading = b => this.setState({ loading: b });

  setInputNome = b => this.setState({ inputNome: b });

  handleInputNomeChange = event => {
    const {
      target: { value },
    } = event;
    this.setInputNome(value);
    this.handleErrorsInputNome(false);
  };

  handleErrorsInputNome = (error_inputNome) => {
    this.setState({ error_inputNome });
  }

  validateForm(success) {
    let errors_temp = false;
    const formData = {};

    if (!this.id) {
      toast('Modalidade de inválido!', { type: toast.TYPE.ERROR });
      return;
    }

    if (!this.state.inputNome || !this.state.inputNome.length) {
      this.handleErrorsInputNome(true);
      errors_temp = true;
    }

    if (errors_temp) {
      return;
    }

    formData.id = this.id;
    formData.nome = this.state.inputNome.trim();

    success(formData);
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.validateForm(async formData => {
      this.setLoading(true);
      try {
        const { data } = await api.put(
          endpoints.product.modality.updateProductModality,
          formData
        );
        toast(data.message, { type: toast.TYPE.SUCCESS });
        this.setLoading(false);
        this.history.push(productPaths.productModality);
      } catch (error) {
        this.setLoading(false);
        showMessageError(error);
      }
    });
  };

  render() {
    return (
      <div className="defaultFormContainer">
        <Modal show={this.state.loading} loading />
        <SidebarPageHeader
          mainMenu="Produto"
          pageName="Editar Modalidade"
          breadcrumbs={[{
            label: 'Modalidade',
            link: productPaths.productModality,
          }]}
          button1={{
            label: 'Salvar',
            onClick: () => this.handleSubmit,
            main: true,
          }}
          openButtonSelect
          buttonCancelHandler={() => this.history.goBack()}
        />

        <form className="defaultForm" onSubmit={this.handleSubmit}>
          <div className="infoCard">
            <span id="title">Dados da Modalidade</span>
            <div className="rowContainer">
              <div className="inputHolder defaultFlex noMarginRight">
                <span>Nome da Modalidade *</span>
                <input
                  type="text"
                  name="nome"
                  value={this.state.inputNome}
                  onChange={this.handleInputNomeChange}
                />
                {this.state.error_inputNome && (
                  <small style={{ color: 'red' }}>Campo obrigatório</small>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default EditProductModality;
